module.exports = __webpack_public_path__ + "img/slytherins_locket.e4a6000f.jpg";